<template>
  <BaseModal modal-content-class="unsub">
    <div class="content">
      <h1>{{ $_translations.value.modal_unsubscribe_via_sms_title }}</h1>

      <BaseImage
        src="/static/images/modals/unsubscribe/unsubscribe_icon.svg"
        alt="unsubscribe icon"
        image-class="top_img"
      />

      <p>
        <span class="white_bold">
          <span class="yellow_bold">
            {{ authStore.userUsername }}
          </span>,
          {{ $_translations.value.modal_unsubscribe_via_sms_subtitle }}
        </span>
      </p>

      <p>{{ $_translations.value.modal_unsubscribe_via_sms_description }}</p>

      <p>{{ $_translations.value.modal_unsubscribe_via_sms_instructions_pt1 }}
        <span class="white_bold">
          [<span class="yellow_bold">
            {{ $_translateByOperator('modal_unsubscribe_via_sms_instructions_pt2') }}
          </span>]
        </span>
        {{ $_translations.value.modal_unsubscribe_via_sms_instructions_pt3 }}
        <span class="yellow_bold">
          {{ $_translateByOperator('modal_unsubscribe_via_sms_instructions_pt4') }}
        </span>
        .
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import useAuthStore from '@/store/modules/auth.js';

const authStore = useAuthStore();
</script>
